import { Box, Grid, Typography } from "@mui/material";
import React from "react";
import { useAppSelector } from "../../assets/hooks";
import { Chat } from "../../types/types";
import AdvisorChatComponent from "../../components/advisorChatComponent";

const Advisors = () => {
  const advisorchats = useAppSelector((state) => state.chats);

  return (
    <Box sx={{
      overflowY: "scroll",
      height: "450px",
      "&::-webkit-scrollbar": {
        width: "12px",
      },
      "&::-webkit-scrollbar-thumb": {
        backgroundColor: "#fff",
        borderRadius: "8px",
      },
      "&::-webkit-scrollbar-track": {
        backgroundColor: "#fff",
      },
      width:"100%",
      mt:1
    }}>
      <Grid
        container
        spacing={2}
        sx={{mt:0}}
      >
        {advisorchats?.data?.advisors?.length > 0 ? advisorchats?.data?.advisors?.map((item: Chat, i) => (
          <Grid item xs={12} key={i}>
            <AdvisorChatComponent data={item} />
          </Grid>
        )) : 
        <Box sx={{height:"5rem",borderRadius:"20px",display:"flex",justifyContent:"center",alignItems:"center",width:"100%"}}>
        <Typography color="#3B3F76">Start a new chat</Typography>
        </Box>
        }
      </Grid>
     
    </Box>
  );
};

export default Advisors;
